import { render, staticRenderFns } from "./NawComponent.vue?vue&type=template&id=24f6a132&"
import script from "./NawComponent.vue?vue&type=script&lang=ts&"
export * from "./NawComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NawComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports